import * as RadixTooltip from "@radix-ui/react-tooltip";
import { forwardRef } from "react";
import { cn } from "@/lib/utils/cn";

export const TooltipProvider = RadixTooltip.Provider;
export const Tooltip = RadixTooltip.Root;
export const TooltipTrigger = RadixTooltip.Trigger;

export const TooltipContent = forwardRef<HTMLDivElement, RadixTooltip.TooltipContentProps>(
  function TooltipContent({ className, sideOffset = 6, ...rest }, ref) {
    return (
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          ref={ref}
          sideOffset={sideOffset}
          className={cn(
            "z-[120] rounded-md border border-[var(--surface-line-strong)] bg-[var(--bg-elev)]",
            "px-2.5 py-1.5 text-xs text-text-strong shadow-[0_20px_40px_-20px_rgba(0,0,0,0.7)]",
            className,
          )}
          {...rest}
        />
      </RadixTooltip.Portal>
    );
  },
);
